import type { DeviceEntity } from './entity/deviceEntity';
import type { DeviceIRepository } from './entity/deviceIRepository';

import { DomainServiceBase } from '@/domain/domainServiceBase';

/**
 * デバイスドメインサービス
 */
export class DeviceDomainService extends DomainServiceBase {
  private deviceRepository!: DeviceIRepository;

  /**
   * Injection
   * @param deviceRepository deviceRepository
   */
  public inject(
    deviceRepository: DeviceIRepository,
  ) {
    this.deviceRepository = deviceRepository;
  }

  /**
   * トークンリスト取得
   * @returns リスト
   */
  async getTokenList() {
    const items = await this.deviceRepository.getAllList();
    const tokenList = items.map((item) => item.token);
    return tokenList;
  }

  /**
   * デバイス作成
   * @param entity entity
   * @returns 結果
   */
  async createDevice(entity: DeviceEntity) {
    const result = await this.deviceRepository.create(entity);
    return result;
  }

  /**
   * デバイス削除
   * @param entity entity
   * @returns 結果
   */
  async deleteDevice(entity: DeviceEntity) {
    const result = await this.deviceRepository.delete(entity);
    return result;
  }
}
